import { getCompanyState } from '../utils';

export const selectCurrent = (state) => getCompanyState(state).current;
export const selectCurrentId = (state) => selectCurrent(state)?.id;
export const selectCurrentName = (state) => selectCurrent(state)?.name;

export const selectSearch = (state) => getCompanyState(state).search;

export const createIsActiveSelector = (companyId) => (state) =>
  companyId === selectCurrentId(state);
